import type { components } from './auto-gen-types'
import type { ShareType } from '../pages/ShareAlbum/permission_table'
import { apiPhotoToSharePhoto, apiUserToUser } from './converters'

type APIShareType = components['schemas']['Share']['share_type']
type APIShare = components['schemas']['Share']
type APIPhoto = components['schemas']['Photo']

const shareTypeToAPI: Record<ShareType, APIShareType> = {
  'invite_only': 'INVITE_ONLY',
  'invite_plus': 'INVITE_PLUS',
  'public': 'PUBLIC',
  'public_lock': 'PUBLIC_PASSWORD',
  'invite_only_public_view': 'INVITE_ONLY_PUBLIC_VIEW',
  'invite_plus_public_view': 'INVITE_PLUS_PUBLIC_VIEW'
}

const shareTypeFromAPI: Record<APIShareType, ShareType> = {
  'INVITE_ONLY': 'invite_only',
  'INVITE_PLUS': 'invite_plus',
  'PUBLIC': 'public',
  'PUBLIC_PASSWORD': 'public_lock',
  'INVITE_ONLY_PUBLIC_VIEW': 'invite_only_public_view',
  'INVITE_PLUS_PUBLIC_VIEW': 'invite_plus_public_view'
}

export const convertShareTypeToAPI = (share_type: ShareType | undefined): APIShareType | undefined =>
  share_type === undefined ? undefined : shareTypeToAPI[share_type]

export const convertShareTypeFromAPI = (share_type: APIShareType): ShareType =>
  shareTypeFromAPI[share_type]

export const apiSharePhotoToPhoto = (photo: APIPhoto) => ({
  ...apiPhotoToSharePhoto(photo),
  favorite: photo.is_favorite ?? false
})

export const apiSharePhotosToPhotos = (photos: APIPhoto[]) =>
  photos.map(apiSharePhotoToPhoto)

export const apiShareToShareWithLength = (share: APIShare & { photos_count?: number }) => ({
  id: share.album_id,
  name: share.name,
  thumbnail_url: share.thumbnail_url || '',
  last_append: new Date(share.last_photo_added_at),
  owner: apiUserToUser(share.owner),
  approval_awaiting_users: (share.approval_awaiting_users || []).map(info => apiUserToUser(info.user)),
  invitation_users: (share.invitation_users || []).map(info => apiUserToUser(info.user)),
  members: (share.members || []).map(apiUserToUser),
  share_type: convertShareTypeFromAPI(share.share_type),
  auto_approve: share.auto_approve ?? false,
  password: share.password || '',
  password_version: share.password_version ?? 0,
  is_sensitive: share.is_sensitive ?? false,
  photos: [],
  photos_length: share.photos_count ?? share.photos?.length ?? 0
})
